// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"1511": "__federation_expose_auth","5900": "__federation_expose_shellContext",}[chunkId] + "." + {"1511": "a9ae4f01dba72500","5900": "b5ff5796e9ada6a4",}[chunkId] + ".js"
}